import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import { getBlogList } from "../../Actions/TourAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        reducer: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getBlogList: () => dispatch(getBlogList())
});

function getBackgroudImage(tour, type = 0) {
    var image = ""
    if (type == 0) {
        image = API_URL + "/" + tour.image
    } else {
        var path = tour.home_image != "" ? tour.home_image : tour.image

        image = API_URL  + path

    }

    return image
}

function getLimit(char, num) {
    var title = char

    title = title.length > num ? title.substring(0, num) + "..." : title

    return title
}

class BlogListing extends Component {

    constructor(props) {
        super(props);

        var typingTimer = null;

        this.state = {

        }
        this.props.getBlogList()
    }

    componentDidMount() {

        AOS.init({
            duration: 800,
            once: true
        });

        window.scrollTo(0, 0)
        window.addEventListener("scroll", this.handleScroll)
    }

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            <div className="page-title">
                <div className="container title-cont">
                    <div className="row">
                        <div className="col-lg-12 title-inner">
                            <div className="breadcrumb-links">
                                <a href="/">Home</a>   <span className="sep"></span> Blog
                            </div>
                            <h1 id="tour-title">Blog</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container feature-box-wrap">
                <div className="latest-post-wrap">
                    <div className="container">
                        <div className="row">
                            <h4 className="blog-h4 col-md-12"> Top Stories</h4>
                            <br />
                        </div>
                    </div>
                </div>
                <div className="row">
                    {this.props.reducer.blogs.length > 0 ? this.props.reducer.blogs.slice(0, 2).map((blog, index) => (<div className="col-lg-6">
                        <div className="feature-post-wrap">
                            <a href={"blog/" + blog.permalink} className="featured-link">
                                <img src={getBackgroudImage(blog, 0)} alt="" width="556" height="420" />
                                <div className="feature-post-info">
                                    <div className="feature-date">
                                        <div className="f-box">Featured</div>
                                        <div className="b-date">{blog.date}</div>
                                    </div>
                                    <div className="f-blog-title">
                                        <h4>{getLimit(blog.title, 40)}</h4>
                                    </div>
                                    <div className="f-blog-contents">

                                        <div
                                            dangerouslySetInnerHTML={{ __html: getLimit(blog.description, 150) }}
                                        />
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>)) : null}
                </div>
            </div>


            <div className="latest-post-wrap">
                <div className="container">
                    <div className="row">
                        <h4 className="blog-h4 col-md-12"> Latest Updates</h4>
                    </div>
                </div>

                <div className="lp-blocks">
                    <div className="container">
                        <div className="row">

                            {this.props.reducer.blogs.length > 0 ? this.props.reducer.blogs.slice(2).map((blog, index) => (<div className="col-md-4">
                                <div className=" wow fadeInUp">
                                    <div className="grid-sizer"></div>
                                    <div className="grid-item">
                                        <div className="lp-blogwrap">
                                            <div>
                                                <a href={"blog/" + blog.permalink}>
                                                    <img src={getBackgroudImage(blog, 1)} className="block-img" width="360"
                                                        height="310" />
                                                </a>
                                            </div>
                                            <div className="lp-content">
                                                <div className="lb-date">{blog.date}</div>

                                                <a style={{ minHeight: 60 }} href={"blog/" + blog.permalink}>
                                                    {getLimit(blog.title, 40)}
                                                </a>
                                                <p>

                                                    <div dangerouslySetInnerHTML={{ __html: getLimit(blog.description, 140) }} />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            )) : null}
                        </div>
                    </div>
                </div>
            </div>


            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(BlogListing);